import { bridgeCallFunc } from './instantLoaded/tools';

// Platform specific cellular types.
// IOS:
// CTRadioAccessTechnologyGPRS
// CTRadioAccessTechnologyEdge
// CTRadioAccessTechnologyWCDMA
// CTRadioAccessTechnologyHSDPA
// CTRadioAccessTechnologyHSUPA
// CTRadioAccessTechnologyCDMA1x
// CTRadioAccessTechnologyCDMAEVDORev0
// CTRadioAccessTechnologyCDMAEVDORevA
// CTRadioAccessTechnologyCDMAEVDORevB
// CTRadioAccessTechnologyeHRPDA
// CTRadioAccessTechnologyLTE

// Android:
// NETWORK_TYPE_UNKNOWN
// NETWORK_TYPE_GPRS
// NETWORK_TYPE_EDGE
// NETWORK_TYPE_UMTS
// NETWORK_TYPE_CDMA
// NETWORK_TYPE_EVDO_0
// NETWORK_TYPE_EVDO_A
// NETWORK_TYPE_1xRTT
// NETWORK_TYPE_HSDPA
// NETWORK_TYPE_HSUPA
// NETWORK_TYPE_HSPA
// NETWORK_TYPE_IDEN
// NETWORK_TYPE_EVDO_B
// NETWORK_TYPE_LTE
// NETWORK_TYPE_EHRPD
// NETWORK_TYPE_HSPAP
// NETWORK_TYPE_GSM

export enum NetWorkType {
  Unknown,
  WIFI,
  CELLULAR
}

export const getNetWorkInfo = (): Promise<{ networkType: NetWorkType }> => {
  return new Promise((resolve) => {
    bridgeCallFunc(() => {
      window.bridgeCallHandler('getNetworkInfo', {}, (data: { networkType: NetWorkType; cellularType: string; data: any }) => {
        resolve(data?.networkType !== undefined ? data : (data?.data || {}));
      });
    });
  });
};
